<script>
    export let className = "";
</script>

<div class={`container ${className}`}>
	<div>
		<slot name="left" />
	</div>
	<div>
		<slot name="right" />
	</div>
</div>

<style>
	.container {
		display: flex;
		justify-content: space-between;
        padding-left: 0;
        padding-right: 0;
	}
</style>
